<template>
  <div class="button-tab-box">
    <p
      :class="[cssName(index), ElIndex === index ? 'active' : 'not']"
      v-for="(item, index) in textList"
      :key="index"
      @click="handleClick(item, index)"
    >
      {{ item }}
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex';
/**
 * [props description]
 * @textList ['leftname',....,'rightName'] 显示名称
 * @ElIndex  默认index
 * @button-tab-change  return {item,index}
 */
export default {
  props: {
    textList: {
      type: Array,
      default() {
        return [];
      }
    },
    defaultIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      ElIndex: 0
    };
  },

  methods: {
    cssName(index) {
      if (index === 0) {
        return 'left';
      } else if (index === this.textList.length - 1) {
        return 'right';
      } else {
        return 'content';
      }
    },
    handleClick(item, index) {
      // this.$emit('update:ElIndex',index)
      this.ElIndex = index;
      // this.$emit('button-tab-change',{item,index})
    }
  },
  watch: {
    defaultIndex: {
      immediate: true,
      handler(v) {
        this.ElIndex = v;
      }
    },
    ElIndex(v) {
      this.$emit('button-tab-change', v);
    }
  },
  computed: {
    ...mapState({
      isButtonActive: state => state.isButtonActive
    })
  },
  created() {
    if (this.isButtonActive == 'Bingli') {
      this.ElIndex = 1;
    }
  }
};
</script>

<style lang="less" scoped>
.button-tab-box {
  width: 100%;
  display: flex;
  p {
    flex: 1;
    text-align: center;
    height: 0.7733rem /* 58/75 */;
    line-height: 0.7733rem /* 58/75 */;
    border: 1px solid #3699ff;
    font-size: 0.4267rem /* 32/75 */;
    color: #fff;
  }
  .left {
    border-radius: 8px 0 0 8px;
  }
  .right {
    border-radius: 0 8px 8px 0;
  }
  .active {
    background: #3699ff !important;
    color: #fff;
  }
  .not {
    background: #fff;
    color: #009aff;
  }
}
</style>
